<app-fp-edit (formDataOutput)="getChildFormData($event)" *ngIf="!submitted" [serverError]="serverError"> </app-fp-edit>
<app-fp-confirmation
  [resetPasswordLink]="resetPasswordLink"
  [emailAddress]="usernameOrEmail"
  *ngIf="submitted"
></app-fp-confirmation>
